import { Divider } from "@kamae-apps/shared/Components/Molecules/Dropdown/Components/Divider"
import { COMPANY_STATUS } from "@kamae-apps/shared/Types/Company"
import { LOGIN_METHOD } from "@kamae-apps/shared/Types/Company"
import { TEAMS_MANAGED_BY } from "@kamae-apps/shared/Types/Company"
import { OnboardingTasksKeys } from "@kamae-apps/shared/Types/Onboarding"
import PrimaryButton from "@kamae-apps/shared/old/Component/Button/PrimaryButton"
import Spinner from "@kamae-apps/shared/old/Component/Button/Spinner"
import { ConditionalRender } from "@kamae-apps/shared/old/Component/ConditionalRender/ConditionalRender"
import CalendarInput from "@kamae-apps/shared/old/Component/Input/CalendarInput"
import FileInput from "@kamae-apps/shared/old/Component/Input/FileInput"
import Input from "@kamae-apps/shared/old/Component/Input/Input"
import Select from "@kamae-apps/shared/old/Component/Input/Select"
import Slider from "@kamae-apps/shared/old/Component/Input/Slider"
import clsx from "clsx"
import React, { FC } from "react"
import { isValidDomain } from "../../../../../utils"
import Checked from "../../../../Icons/Checked"
import UnChecked from "../../../../Icons/UnChecked"
import { MailDomainPills } from "../../Components/MailDomainPills"
import { NotificationsSection } from "../../Components/NotificationsSection"
import { InformationContainerProps, useInformationContainer } from "./useInformationContainer"

export const InformationContainer: FC<InformationContainerProps> = ({ company, setCompany, isNewCompany }) => {
  const {
    loading,
    valid,
    logo,
    setLogo,
    updateName,
    updateIDP,
    loginOptions,
    updateLoginMethod,
    defaultLanguage,
    updateLanguage,
    newDomain,
    addNewDomain,
    setNewDomain,
    domains,
    removeDomain,
    companyOnboarding,
    options,
    updateStatus,
    updateMaxUsers,
    updateMaxAdmins,
    updateStartLicenseDate,
    setIsLicenseStartDateValid,
    updateEndLicenseDate,
    setIsLicenseEndDateValid,
    globalModules,
    check,
    setCheck,
    updatePhishing,
    updateSSO,
    updateLMS,
    companyTeamsInstallation,
    companySlackInstallation,
    updateDirSync,
    saveCompany,
    updateAutomatedEmails,
    updateExternalCustomerId,
    teamUpdateManagerOptions,
    updateTeamUpdateManager,
  } = useInformationContainer(company, setCompany, isNewCompany)

  return (
    <div className={"h-full p-3"}>
      <form
        className={"relative mt-4 flex h-full w-full flex-col items-center gap-6"}
        onSubmit={e => e.preventDefault()}
      >
        <div className={"flex w-full flex-col items-center gap-2 p-2"}>
          <div className={"flex w-full gap-4"}>
            <div className={"flex w-1/2 flex-col items-center gap-6"}>
              <h3 className={"text-lg"}>Informations Entreprise</h3>
              <Input
                className={clsx("!w-full", company.name !== "" ? "" : "border-2 border-red-500")}
                disabled={loading}
                placeholder={"Nom"}
                value={company.name}
                placeholderColor={company.name !== "" ? "" : "text-red-500"}
                onChange={e => {
                  updateName(e.target.value)
                }}
              />
              <ConditionalRender condition={company.status === COMPANY_STATUS.STARTER}>
                <Input
                  className={"!w-full"}
                  placeholder={"External client ID"}
                  disabled={loading}
                  value={company.external_customer_id ?? ""}
                  onChange={e => updateExternalCustomerId(e.target.value)}
                />
              </ConditionalRender>
              <FileInput
                className={"!w-full"}
                placeHolder={"Logo"}
                value={logo}
                setValue={setLogo}
                disabled={loading}
              />
              <Select
                className={"!z-20 !w-full"}
                defaultValue={company.defaultLanguageId}
                options={defaultLanguage}
                placeholder={"Langue par défaut"}
                onChange={e => {
                  updateLanguage(parseInt(e.target.value))
                }}
                disabled={loading}
              />
              <Select
                className={" !w-full"}
                options={loginOptions}
                disabled={loading}
                placeholder={"Méthode de connexion"}
                defaultValue={company.loginMethod}
                onChange={e => {
                  updateLoginMethod(e.target.value as LOGIN_METHOD)
                }}
              />
              <ConditionalRender condition={!isNewCompany}>
                <Input
                  className={"!w-full"}
                  disabled={loading}
                  placeholder={"IDP"}
                  value={company.idp ?? ""}
                  onChange={e => {
                    updateIDP(e.target.value)
                  }}
                />
              </ConditionalRender>
              {isNewCompany && company.loginMethod === LOGIN_METHOD.MAGIC_LINK && (
                <div className={"w-full"}>
                  <div className={"flex w-full items-center gap-4"}>
                    <Input
                      onEnterPress={addNewDomain}
                      className={"!m-0 !w-full"}
                      placeholder={"Ajouter un domaine"}
                      value={newDomain}
                      onChange={e => setNewDomain(e.target.value)}
                    />
                    <PrimaryButton
                      className={"!mx-0"}
                      disabled={!isValidDomain(newDomain)}
                      onClick={addNewDomain}
                    >
                      Ajouter
                    </PrimaryButton>
                  </div>
                  <div className={"mt-2 flex w-full flex-wrap gap-3"}>
                    {domains === undefined
                      ? "Chargement"
                      : domains?.map(v => (
                          <MailDomainPills
                            value={v}
                            key={v}
                            remove={data => {
                              removeDomain(data)
                            }}
                          />
                        ))}
                  </div>
                </div>
              )}
              <div className={"flex w-full gap-5"}>
                {!isNewCompany && (
                  <div className={"flex flex-col items-center justify-evenly gap-4 border-l-2 border-gray-100 pl-3"}>
                    <h3 className={"mb-3 text-lg"}>Suivi Onboarding</h3>
                    {company.onboarding_completed ? (
                      <div className={"flex flex-col gap-2"}>
                        <p>Phase d'onboarding terminée</p>
                        {companyOnboarding?.onboarding_closed_at && (
                          <p className={"text-sm text-gray-500"}>
                            Clôturée le{" "}
                            {new Date(companyOnboarding.onboarding_closed_at).toLocaleDateString("fr-FR")}
                          </p>
                        )}
                        <p>
                          Envoi des emails d'invitation : {companyOnboarding?.onboarding_email_sent_at ? "✅" : "❌"}
                        </p>
                      </div>
                    ) : (
                      <div className={"grid grid-cols-2 grid-rows-3 gap-y-3"}>
                        {companyOnboarding ? (
                          <>
                            {Object.entries(companyOnboarding.tasks)
                              .filter(([key]) => key !== "onboarding_email_sent" && key !== "sso_configured")
                              .map(([key, value]) => (
                                <div
                                  className={"flex gap-2 p-1"}
                                  key={key}
                                >
                                  {value ? <Checked /> : <UnChecked />}
                                  <span>{getOnboardingTaskName(key as OnboardingTasksKeys)}</span>
                                </div>
                              ))}
                          </>
                        ) : (
                          <Spinner className={"text-primary"} />
                        )}
                      </div>
                    )}
                  </div>
                )}
                <div className={"flex flex-col gap-2 border-l-2 border-gray-100 pl-3"}>
                  <NotificationsSection
                    company={company}
                    onAutomatedEmailChange={e => {
                      updateAutomatedEmails(e.target.checked)
                    }}
                  />
                </div>
                {company.dir_sync_activated && (
                  <div className={"flex flex-col gap-4 border-l-2 border-gray-100 pl-3"}>
                    <h3 className={"mb-2 w-full text-center text-lg"}>Mise à jour des équipes</h3>
                    <p>Indique qui est en charge de la mise à jour des équipes avec une synchro SCIM.</p>
                    <div className={"flex w-full justify-start gap-2"}>
                      <Select
                        className={"!z-20 !w-full"}
                        defaultValue={company.teams_managed_by}
                        options={teamUpdateManagerOptions}
                        placeholder={"Gestionnaire"}
                        onChange={e => {
                          updateTeamUpdateManager(e.target.value as TEAMS_MANAGED_BY)
                        }}
                        disabled={loading}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={"flex w-1/2 flex-col items-center gap-6"}>
              <h3 className={"text-lg"}>Informations License</h3>
              <Select
                className={"!z-30 !w-full"}
                defaultValue={company.status}
                options={options}
                placeholder={"Status"}
                onChange={e => {
                  updateStatus(parseInt(e.target.value))
                }}
                disabled={loading}
              />
              <div className={"flex w-full justify-between"}>
                <Input
                  className={clsx("mx-1 !w-1/2", company.max_users ? "" : "border-2 border-red-500")}
                  type={"number"}
                  disabled={loading}
                  placeholder={"Nombre d'utilisateurs max"}
                  placeholderColor={company.max_users ? "" : "text-red-500"}
                  value={company.max_users}
                  onChange={e => {
                    updateMaxUsers(parseInt(e.target.value))
                  }}
                />
                <Input
                  className={clsx("!w-1-2 mx-1", company.max_admins ? "" : "border-2 border-red-500")}
                  type={"number"}
                  disabled={loading}
                  placeholder={"Nombre d'admins max"}
                  placeholderColor={company.max_admins ? "" : "text-red-500"}
                  value={company.max_admins}
                  onChange={e => {
                    updateMaxAdmins(parseInt(e.target.value))
                  }}
                />
              </div>
              <CalendarInput
                className={"z-20 w-full"}
                value={company.license_start_date}
                setValue={updateStartLicenseDate}
                disabled={loading}
                placeHolder={"Début de contrat"}
                setIsDateValid={setIsLicenseStartDateValid}
              />
              <CalendarInput
                className={"z-10 w-full"}
                value={company.license_end_date}
                setValue={updateEndLicenseDate}
                disabled={loading}
                placeHolder={"Fin de contrat"}
                setIsDateValid={setIsLicenseEndDateValid}
              />
              <div className={"flex w-full gap-20"}>
                <div className={"flex flex-col gap-4 border-l-2 border-gray-100 pl-3"}>
                  <h3 className={"mb-2 w-full text-center text-lg"}>Modules E-Learning</h3>
                  {globalModules?.map((module, i) => (
                    <div
                      className={"flex justify-start"}
                      key={i}
                    >
                      <Slider
                        id={`module_${module.id}`}
                        className={"m-1"}
                        value={module.id}
                        checked={check[i]}
                        onChange={() => {
                          setCheck(check.map((module, index) => (i === index ? !module : module)))
                        }}
                      />
                      <label
                        htmlFor={`module_${module.id}`}
                        className={"flex grow items-center justify-between"}
                      >
                        <span className={"mr-2"}>{module.name}</span>
                      </label>
                    </div>
                  ))}
                </div>
                <div className={"flex flex-col gap-4 border-l-2 border-gray-100 pl-3"}>
                  <h3 className={"mb-2 w-full text-center text-lg"}>Options</h3>
                  <div className={"flex w-full justify-start"}>
                    <Slider
                      id={"companyHasPhishing"}
                      checked={company.phishing_enabled ?? false}
                      onChange={e => {
                        updatePhishing(e.target.checked)
                      }}
                      className={"m-1"}
                    />
                    <label
                      htmlFor={"companyHasPhishing"}
                      className={"flex grow items-center justify-between"}
                    >
                      <span className={"mr-2"}>Phishing</span>
                    </label>
                  </div>
                  <div className={"flex w-full justify-start"}>
                    <Slider
                      id={"companyHasSSO"}
                      checked={company.sso_enabled ?? false}
                      onChange={e => {
                        updateSSO(e.target.checked)
                      }}
                      className={"m-1"}
                    />
                    <label
                      htmlFor={"companyHasSSO"}
                      className={"flex grow items-center justify-between"}
                    >
                      <span className={"mr-2"}>SSO</span>
                    </label>
                  </div>
                  <div className={"flex"}>
                    <Slider
                      id={"companyHasDirSync"}
                      checked={company.dir_sync_enabled}
                      onChange={e => {
                        updateDirSync(e.target.checked)
                      }}
                      className={"m-1"}
                      disabled={!company.sso_enabled}
                    />
                    <label
                      htmlFor={"companyHasDirSync"}
                      className={clsx("flex items-center", company.sso_enabled || "text-gray-300")}
                    >
                      <span>SCIM</span>
                    </label>
                  </div>
                  <div className={"flex w-full justify-start"}>
                    <Slider
                      id={"companyHasLMS"}
                      checked={company.lms_enabled ?? false}
                      onChange={e => {
                        updateLMS(e.target.checked)
                      }}
                      className={"m-1"}
                    />
                    <label
                      htmlFor={"companyHasLMS"}
                      className={"flex grow items-center justify-between"}
                    >
                      <span className={"mr-2"}>LMS</span>
                    </label>
                  </div>
                  <div className={"flex"}>
                    <Slider
                      id={"companyHasTeams"}
                      checked={companyTeamsInstallation?.isInstalled}
                      className={"m-1"}
                      disabled
                    />
                    <label
                      htmlFor={"companyHasTeams"}
                      className={"flex grow items-center justify-between"}
                    >
                      <span className={"mr-2"}>Microsoft Teams</span>
                    </label>
                  </div>
                  <div className={"flex"}>
                    <Slider
                      id={"companyHasSlack"}
                      checked={companySlackInstallation?.isInstalled}
                      className={"m-1"}
                      disabled
                    />
                    <label
                      htmlFor={"companyHasSlack"}
                      className={"flex grow items-center justify-between"}
                    >
                      <span className={"mr-2"}>Slack</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={"flex"}>
          <PrimaryButton
            type={"submit"}
            disabled={!valid || loading}
            onClick={saveCompany}
            spinning={loading}
          >
            Sauvegarder
          </PrimaryButton>
        </div>
      </form>
    </div>
  )
}

function getOnboardingTaskName(taskKey: OnboardingTasksKeys) {
  switch (taskKey) {
    case "email_whitelisted":
      return "Whitelister email"
    case "organization_customized":
      return "Personnaliser dojo"
    case "phishing_configured":
      return "Configurer phishing"
    case "users_imported":
      return "Importer collaborateurs"
    case "scim_configured":
      return "Configurer SCIM"
    case "should_send_invitations":
      return "Envoyer les invitations"
    default:
      return "Tâche inconnue"
  }
}
